import module from '../module';
import Constants from '../../../utils/CommonConstants';
import moment from 'moment';

function OrderConfirmationController($scope, $state, cartService) {

    cartService.getCartDetails().then(function (cartDetails) {
        $scope.deliveryTime = moment(cartDetails.deliveryDate).format('LT [on] dddd[,] MMM DD');
    });

    $scope.go = function () {
        $state.go(Constants.RoutingStates.CATALOG);
    };
}

module.controller('Cartonomy.Order.ConfirmationController', ['$scope', '$state', 'CartService', OrderConfirmationController]);


// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderConfirmationController.js